import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import TableLayout from "../../../components/TableLayout";
import TableActions from "../../../components/Common/TableActions";
import {
  SIGNUPQUESTIONDELETE,
  SIGNUPQUESTIONLIST,
} from "../../../services/ApiCalls";
import dataHandler from "../../../hooks/dataHandler";
import moment from "moment";
import Filter from "../../../components/Common/Filter";
import {
  activeInactiveOptions,
  defaultDeleteModelState,
} from "../../../utilities/const";
import { Link } from "react-router-dom";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import CustomPagination from "../../../components/Common/CustomPagination";

const SignUpQuestionList = () => {
  const {
    setBody,

    body,
    data,
    loader,
    deleteModel,
    setDeleteModel,

    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
  } = dataHandler({
    api: SIGNUPQUESTIONLIST,
  });

  const column = [
    {
      head: "Sr. No.",
      accessor: "#",
      component: (item, key) => {
        return <>{key < 9 ? `0${key + 1}` : key + 1}</>;
      },
    },
    {
      head: "Question Type",
      accessor: "questionType",
    },
    {
      head: "Name",
      accessor: "name",
    },
    {
      head: "Answer",
      accessor: "answers",
      component: (item, key) => {
        return (
          <ul style={{ margin: 0, paddingLeft: "20px" }}>
            {Array.isArray(item?.answers) && item.answers.length > 0 ? (
              item.answers.map((ans, index) => <li key={index}>{ans}</li>)
            ) : (
              <li>No answer</li>
            )}
          </ul>
        );
      },
    },

    { head: "Description", accessor: "description" },
    {
      head: "Created At",
      accessor: "date_created_utc",
      component: (item, key) => {
        return (
          <>
            <p>{moment(item.date_created_utc).format("YYYY-MM-DD")}</p>
          </>
        );
      },
    },

    {
      head: "Status",
      accessor: "status",
      component: (item, key, arr) => <span className="">{item?.status}</span>,
    },
    {
      head: "Action",
      accessor: "Action",
      component: (item) => {
        console.log(item, "item");
        return (
          <TableActions
            editUrl={`/signupquestion/edit/${item._id}`}
            // viewLink={`/signupquestion/detail/${item._id}`}
            setDeleteModel={() =>
              setDeleteModel({ show: true, dumpId: item?._id })
            }
          />
        );
      },
    },
  ];

  const [confirmation, setConfirmation] = useState();
  const handleConfirmation = () => setConfirmation(!confirmation);
  return (
    <>
      <ConfirmationPop
        type={"delete"}
        confirmation={deleteModel.show}
        setConfirmation={() => setDeleteModel((p) => defaultDeleteModelState)}
        confirmHandler={() =>
          deleteHandler(() => SIGNUPQUESTIONDELETE({ _id: deleteModel.dumpId }))
        }
      />
      <section className="promocode py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                SignUp Question List
              </h4>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <Filter
                    body={body}
                    setBody={setBody}
                    searchHandler={searchHandler}
                    statusFilterOptionArr={activeInactiveOptions}
                  />
                </div>
                <div className="right">
                  <Link
                    to="/signupquestion/add"
                    className="d-flex btn btn-primary align-items-center justify-content-center fw-sbold commonBtn "
                    style={{ height: 40, minWidth: 100, fontSize: 12 }}
                  >
                    Add New
                  </Link>
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <TableLayout column={column} data={data} loader={loader} />
              <CustomPagination
                total={total}
                pageChangeHandler={paginationHandler}
                body={body}
                setBody={setBody}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default SignUpQuestionList;
